import { KitapoService } from '../services/KitapoService';

const MODULE_PREFIX = 'templates';
const GETTER_TEMPLATES = 'templates';
const MUTATION_FETCHED_TEMPLATES = 'FETCHED_TEMPLATES';
const ACTION_FETCH_TEMPLATES = 'fetchTemplates';

const initialState = {
  templates: [],
};

const getters = {
  [GETTER_TEMPLATES]: state => state.templates,
};

const mutations = {
  [MUTATION_FETCHED_TEMPLATES]: (state, templates) => {
    state.templates = templates;
  },
};

const actions = {
  [ACTION_FETCH_TEMPLATES]: async ({ commit }) => {
    const service = new KitapoService();

    try {
      const templates = await service.fetchReflectionTemplates();
      templates.sort((t1, t2) => t1.sortIndex - t2.sortIndex);

      commit(MUTATION_FETCHED_TEMPLATES, templates);
    } catch (e) {
      console.error('ACTION_FETCH_TEMPLATES FAILED', e);
    }
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};

export const types = {
  getters: {
    templates: `${MODULE_PREFIX}/${GETTER_TEMPLATES}`,
  },
  actions: {
    fetchTemplates: `${MODULE_PREFIX}/${ACTION_FETCH_TEMPLATES}`,
  },
};
